import { createRoot } from 'react-dom/client';
import { ConfirmationDialog } from '@/components/pages/SettingsPage/MainContent/shared/ConfirmationDialog';
import React from 'react';

export enum ConfirmationResult {
  CANCEL = 'CANCEL',
  DONT_SAVE = 'DONT_SAVE',
  SAVE_AND_EXIT = 'SAVE_AND_EXIT',
}

export const confirmDialog = () => {
  return new Promise<ConfirmationResult>((resolve) => {
    const containerElement = document.createElement('div');
    document.body.appendChild(containerElement);

    const root = createRoot(containerElement);

    const handleClose = () => {
      root.unmount();
      document.body.removeChild(containerElement);
    };

    const handleSaveAndExit = () => {
      resolve(ConfirmationResult.SAVE_AND_EXIT);
      handleClose();
    };

    const handleDontSave = () => {
      resolve(ConfirmationResult.DONT_SAVE);
      handleClose();
    };

    const handleCancel = () => {
      resolve(ConfirmationResult.CANCEL);
      handleClose();
    };

    const onOpenChange = (open: any) => {
      if (!open) {
        resolve(ConfirmationResult.CANCEL);
        handleClose();
      }
    };

    root.render(
      <ConfirmationDialog
        isOpened={true}
        onConfirmAction={handleSaveAndExit}
        onDontSaveAction={handleDontSave}
        onCancelAction={handleCancel}
        onOpenChange={onOpenChange}
      />
    );
  });
};
